/**
 * Cookie Manager class
 *
 * @description Utilities class to crud cookies, all cookies will be created under root.
 */
class CookieManager {
  constructor() {}

  createCookie(name, value, days, hours = 0) {
    let expires = "";

    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toGMTString();
    }

    if (hours !== 0) {
      let date = new Date();
      date.setTime(date.getTime() + hours * 60 * 60 * 1000);
      expires = "; expires=" + date.toGMTString();
    }

    let secureFlag = "";
    if (location.protocol === "https:") {
      secureFlag = ";secure";
    }
    document.cookie = name + "=" + value + expires + "; path=/" + secureFlag;
  }

  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  getAllCookies() {
    var cookies = [];
    var allCookies = document.cookie.split(";");
    for (var i = 0; i < allCookies.length; i++) {
      var eqIndex = allCookies[i].indexOf("=");
      cookies.push([
        allCookies[i].substring(0, eqIndex).trim(),
        allCookies[i].substring(eqIndex + 1),
      ]);
    }

    return cookies;
  }

  removeAllCookies() {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      this.removeCookie(cookies[i].split("=")[0]);
    }
  }

  removeCookie(name) {
    this.createCookie(name, "", -1);
  }
}

const cookieManager = new CookieManager();

export { cookieManager };
